<template>
  <v-card class="manual-discount-card">
    <p class="manual-discount-card__title">
      {{ $t('purchaseV2.basket.discount') }}
    </p>
    <v-switch
      :input-value="isDiscountActive"
      :disabled="disabled"
      @change="onToggleDiscount" />
    <v-text-field
      ref="discountInput"
      :value="discountAmount"
      :error-messages="discountErrorMessages"
      :disabled="!isDiscountActive || disabled"
      :loading="isArenaCurrencyLoading"
      suffix="%"
      :rules="discountRules"
      validate-on-blur
      type="text"
      inputmode="decimal"
      hide-details="auto"
      @input="onDiscountInput"
      class="manual-discount-field" />
  </v-card>
</template>

<script>
export default {
  name: 'BasketManualDiscountCard',
  props: {
    disabled: { type: Boolean, default: false },
    discountAmount: { type: Number, required: true },
    doesDiscountAmountExceedSubtotal: { type: Boolean, default: false },
    isArenaCurrencyLoading: { type: Boolean, default: false },
    isDiscountActive: { type: Boolean, required: true },
    maxDiscountPercentage: { type: Number, default: 100 },
  },
  data() {
    return {
      discountDebounce: null,
    }
  },
  computed: {
    discountRules() {
      if (!this.isDiscountActive) return []
      const requiredMessage = this.$t('validation.required')
      return [
        (value) => {
          if (value || value === 0 || value === '0') return true
          return requiredMessage
        },
      ]
    },
    discountErrorMessages() {
      const tKey =
        'purchaseV2.basket.paymentValidation.discountExceedsMaxPercentage'
      return this.doesDiscountAmountExceedSubtotal
        ? this.$t(tKey, { maxPct: this.maxDiscountPercentage })
        : []
    },
  },
  methods: {
    onToggleDiscount(value) {
      return this.$emit('update:is-discount-active', Boolean(value))
    },
    onDiscountInput(value) {
      clearTimeout(this.discountDebounce)

      this.discountDebounce = setTimeout(() => {
        const normalized =
          typeof value === 'string' ? value.replace(',', '.') : value
        const parsedValue = Number.parseFloat(normalized)
        const sanitized = Number.isFinite(parsedValue) ? parsedValue : 0
        const clamped = Math.min(
          Math.max(sanitized, 0),
          this.maxDiscountPercentage,
        )
        const rounded = Math.round(clamped * 100) / 100
        this.$emit('update:discount-amount', rounded)
      }, 1000)
    },
  },
  watch: {
    isDiscountActive(newValue) {
      if (!newValue && this.$refs.discountInput) {
        this.$refs.discountInput.resetValidation()
      }
    },
  },
}
</script>

<style scoped>
.manual-discount-card {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1.625rem;
  padding: 0.5rem;

  --card-title-color: var(--v-primary-text-darken4);

  &.theme--dark {
    --card-title-color: var(--v-primary-text-base);
  }
}

.manual-discount-card__title {
  margin-bottom: 0;
  font-size: 1rem;
  font-weight: 600;
  color: var(--card-title-color);
}

.manual-discount-field {
  margin: 0 0 18px 0;
  min-width: 3.75rem;
}
</style>
